import Vue from "vue";
import App from "./App.vue";
import {getField} from "./utils/index.js";
var fieldTerms = require('@/assets/fields.json');

Vue.config.productionTip = false;

var forms = document.getElementsByTagName('form');
Array.prototype.forEach.call(forms, function(form, index) { 
  
  // Supports 5 autocomplete addresses
  for(let i=0; i < 5; i++){
    // If street address is under a grouped HTML Element with class defined in fieldTerms.grouped.class + i
    // Look for input[type=text] and select
    let groupedAddress = form.querySelectorAll('.'+fieldTerms.grouped.class+i+' input[type=text], .'+fieldTerms.grouped.class+i+' select');
    
    if(groupedAddress.length > 0){
      const street = getField(groupedAddress, fieldTerms.street.include, fieldTerms.street.exclude);
      if(!!street){
        new Vue({
          render: h => h(App),
            data: {
            id: street.id,
            name: street.name,
            formElements: groupedAddress
          }
        }).$mount(street);
      }
    }

    // If street address is under a HTML Element with class defined in fieldTerms.street.class + i
    let singleAddress = form.querySelectorAll('.'+fieldTerms.street.class+i+' input[type=text], .'+fieldTerms.city.class+i+' input[type=text], .'+fieldTerms.state.class+i+' select, .'+fieldTerms.state.class+i+' input[type=text], .'+fieldTerms.country.class+i+' select, .'+fieldTerms.country.class+i+' input[type=text], .'+fieldTerms.postal.class+i+' input');
    if(singleAddress.length > 0){

      const street = getField(singleAddress, fieldTerms.street.include, fieldTerms.street.exclude);
      if(!!street){
        new Vue({
          render: h => h(App),
            data: {
            id: street.id,
            name: street.name,
            formElements: singleAddress
          }
        }).$mount(street);
      }
    }
  }
});
